import React from 'react';
import { CanvasPreview } from './canvasPreview';
import { VortexPreview } from './vortexPreview';
import { RasterPreview } from './rasterPreview';
export function Preview(_ref) {
  let {
    children,
    user,
    view,
    renderOptions,
    cimDocUrl,
    throttleWaitMs = 300,
    onError,
    onPaint
  } = _ref;
  if (view.type === 'vortex') {
    if ((renderOptions === null || renderOptions === void 0 ? void 0 : renderOptions.vortex) === 'raster') {
      return React.createElement(RasterPreview, {
        children: children,
        renderOptions: renderOptions,
        view: view,
        cimDocUrl: cimDocUrl,
        throttleWaitMs: throttleWaitMs,
        onError: onError,
        onPaint: onPaint
      });
    } else {
      return React.createElement(VortexPreview, {
        user: user,
        view: view,
        cimDocUrl: cimDocUrl,
        children: children,
        renderOptions: renderOptions,
        onError: onError,
        onPaint: onPaint
      });
    }
  } else {
    return React.createElement(CanvasPreview, {
      renderOptions: renderOptions,
      children: children,
      user: user,
      view: view,
      cimDocUrl: cimDocUrl,
      throttleWaitMs: throttleWaitMs,
      onError: onError,
      onPaint: onPaint
    });
  }
}